// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-login {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cont-login {
  position: relative;
  width: 50%;
  height: 100%;
}

.rigth-login {
  display: flex;
}

.cont-shadow {
  background: linear-gradient(#003757ef, #020a20f3);
  z-index: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cont-shadow-movil {
  display: none;
}

.logo-login {
  height: 20%;
}

.cont-img-back {
  /* background-image: url('../public/monitoreo_seguritech.png'); */
  background-repeat: no-repeat;
  background-position: center;
  background-size: 150%;
  height: 100vh;
  display: inline-block;
}

.cont-img {
  position: relative;
  width: 100%;
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-show {
  position: relative;
  width: 100%;
  height: 100%;
}

.left-login {
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: linear-gradient(90deg, rgba(255,254,255,1) 0%, rgba(195,195,195,1) 100%); */
  /* background-image: url('/public/back-3.png'); */
  /* background-size: cover; */
  background-repeat: no-repeat;
  background: var(--white-color);
}

.img-top {
  position: absolute;
  height: 20%;
  top: 6%;
  /* left: 38%; */
  z-index: 3;
}

.card_login {
  position: relative;
  width: 70%;
  height: 70%;
  border-radius: 14px;
  z-index: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* box-shadow:  20px 20px 60px #949494,
    -20px -20px 60px #ffffff; */
  background-color: #003757ef;
  ;
}

.bg {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 98%;
  height: 98%;
  z-index: 2;
  background: rgba(255, 255, 255, .95);
  background: linear-gradient(90deg, rgba(255, 254, 255, 1) 0%, rgba(195, 195, 195, 1) 100%);
  -webkit-backdrop-filter: blur(24px);
          backdrop-filter: blur(24px);
  border-radius: 10px;
  overflow: hidden;
  outline: 2px solid white;
}

.blob {
  position: absolute;
  z-index: 2;
  top: 10%;
  left: 10%;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background-color: #0076bb;
  opacity: 1;
  filter: blur(12px);
  animation: blob-bounce 5s infinite ease;
}

@keyframes blob-bounce {
  0% {
    transform: translate(-100%, -100%) translate3d(0, 0, 0);
  }

  25% {
    transform: translate(-100%, -100%) translate3d(100%, 0%, 0%);
  }

  50% {
    transform: translate(-100%, -100%) translate3d(100%, 100%, 0);
  }

  75% {
    transform: translate(-100%, -100%) translate3d(0, 100%, 0);
  }

  100% {
    transform: translate(-100%, -100%) translate3d(0, 0, 0);
  }
}

.login-box {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80%;
  padding: 40px;
  margin: 20px auto;
  transform: translate(-50%, -55%);
  background: transparent;
  /* box-sizing: border-box;
    box-shadow: 0 15px 25px rgba(0,0,0,.6);
    border-radius: 10px; */
}

.login-box p:first-child {
  margin: 0 0 30px;
  padding: 0;
  color: #003757;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  letter-spacing: 1px;
}

.login-box .user-box {
  position: relative;
}

.user-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box .user-box input {
  width: 100%;
  padding: 10px 0;
  font-size: 16px;
  color: #505050;
  margin-bottom: 30px;
  border: none;
  border-bottom: 2px solid #003757;
  border-right: 2px solid #003757;
  outline: none;
  background: transparent;
}

.login-box .user-box label {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px 0;
  font-size: 18px;
  font-weight: bolder;
  color: #003757;
  pointer-events: none;
  transition: .5s;
}

.login-box .user-box input:focus~label,
.login-box .user-box input:valid~label {
  top: -20px;
  left: 0;
  color: #003757;
  font-size: 12px;
}

.login-box form a {
  position: relative;
  display: inline-block;
  padding: 10px 20px;
  font-weight: bold;
  color: #003757;
  font-size: 16px;
  text-decoration: none;
  text-transform: uppercase;
  overflow: hidden;
  transition: .5s;
  margin-top: 40px;
  letter-spacing: 3px
}

.login-box a:hover {
  background: #003757;
  color: #ffffff;
  border-radius: 5px;
}

.login-box a span {
  position: absolute;
  display: block;
}

.login-box a span:nth-child(1) {
  top: 0;
  left: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #003757);
  animation: btn-anim1 1.5s linear infinite;
}

@keyframes btn-anim1 {
  0% {
    left: -100%;
  }

  50%,
  100% {
    left: 100%;
  }
}

.login-box a span:nth-child(2) {
  top: -100%;
  right: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, transparent, #003757);
  animation: btn-anim2 1.5s linear infinite;
  animation-delay: .375s
}

@keyframes btn-anim2 {
  0% {
    top: -100%;
  }

  50%,
  100% {
    top: 100%;
  }
}

.login-box a span:nth-child(3) {
  bottom: 0;
  right: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(270deg, transparent, #003757);
  animation: btn-anim3 1.5s linear infinite;
  animation-delay: .75s
}

@keyframes btn-anim3 {
  0% {
    right: -100%;
  }

  50%,
  100% {
    right: 100%;
  }
}

.login-box a span:nth-child(4) {
  bottom: -100%;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(360deg, transparent, #003757);
  animation: btn-anim4 1.5s linear infinite;
  animation-delay: 1.125s
}

@keyframes btn-anim4 {
  0% {
    bottom: -100%;
  }

  50%,
  100% {
    bottom: 100%;
  }
}

.login-box p:last-child {
  color: #aaa;
  font-size: 14px;
}

.login-box a.a2 {
  color: #fff;
  text-decoration: none;
}

.login-box a.a2:hover {
  background: transparent;
  color: #aaa;
  border-radius: 5px;
}

.MessageErrorCont {
  position: relative;
  /* background-color: red; */
  width: 100%;
  height: 20%;
  top: 80%;
  display: flex;
  justify-content: center;
  align-items: center;

}

.MessageError {
  position: relative;
  width: 90%;
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 3px solid #ff5959;
  background-color: rgba(242, 199, 199, 0.72);
}

.txtMessageError {
  position: relative;
  width: 90%;
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: red;
  word-wrap: break-word;
  font-size: small;
}

/************************Horizontal Movil*************************/
@media (min-width: 500px) and (max-width: 900px) {
  .login-box p:first-child {
    font-size: 0.5rem;
    top: 7%;
    position: absolute;
    left: 30%;

  }

  .login-box .user-box label {
    font-size: 14px;
  }

  .login-box .user-box input {
    padding: 2%;
  }

  .actLogin {
    font-size: 10px !important;
  }

  .actLogin.actDisabled {
    font-size: 10px !important;
  }
}

/************************Movil*************************/
@media (max-width: 500px) {
  .left-login {
    width: 100%;
    /* display: none; */
  }

  .rigth-login {
    display: none;
  }

  .login-box p:first-child {
    font-size: 1rem;
    top: unset;
    /* position: absolute; */
    /* left: 30%; */

  }

  .cont-shadow-movil {
    background: linear-gradient(#003757ef, #020a20f3);
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0%;
  }

  .cont-shadow-movil .logo-login {
    height: 60%;
  }

  .txtMessageError {
    font-size: var(--font-size-xSmall);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iDAAiD;EACjD,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0FAA0F;EAC1F,iDAAiD;EACjD,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB;+BAC6B;EAC7B,2BAA2B;;AAE7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,UAAU;EACV,oCAAoC;EACpC,0FAA0F;EAC1F,mCAA2B;UAA3B,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE;IACE,uDAAuD;EACzD;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,0DAA0D;EAC5D;;EAEA;IACE,uDAAuD;EACzD;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,uBAAuB;EACvB;;0BAEwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,OAAO;EACP,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,WAAW;EACX,WAAW;EACX,wDAAwD;EACxD,yCAAyC;AAC3C;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,yDAAyD;EACzD,yCAAyC;EACzC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;;IAEE,SAAS;EACX;AACF;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,WAAW;EACX,yDAAyD;EACzD,yCAAyC;EACzC;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,OAAO;EACP,UAAU;EACV,YAAY;EACZ,yDAAyD;EACzD,yCAAyC;EACzC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE;IACE,iBAAiB;IACjB,OAAO;IACP,kBAAkB;IAClB,SAAS;;EAEX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,uDAAuD;AACvD;EACE;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,UAAU;IACV,wBAAwB;IACxB,eAAe;;EAEjB;;EAEA;IACE,iDAAiD;IACjD,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,OAAO;EACT;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kCAAkC;EACpC;AACF","sourcesContent":[".main-login {\r\n  height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.cont-login {\r\n  position: relative;\r\n  width: 50%;\r\n  height: 100%;\r\n}\r\n\r\n.rigth-login {\r\n  display: flex;\r\n}\r\n\r\n.cont-shadow {\r\n  background: linear-gradient(#003757ef, #020a20f3);\r\n  z-index: 1;\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.cont-shadow-movil {\r\n  display: none;\r\n}\r\n\r\n.logo-login {\r\n  height: 20%;\r\n}\r\n\r\n.cont-img-back {\r\n  /* background-image: url('../public/monitoreo_seguritech.png'); */\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: 150%;\r\n  height: 100vh;\r\n  display: inline-block;\r\n}\r\n\r\n.cont-img {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.img-show {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.left-login {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* background: linear-gradient(90deg, rgba(255,254,255,1) 0%, rgba(195,195,195,1) 100%); */\r\n  /* background-image: url('/public/back-3.png'); */\r\n  /* background-size: cover; */\r\n  background-repeat: no-repeat;\r\n  background: var(--white-color);\r\n}\r\n\r\n.img-top {\r\n  position: absolute;\r\n  height: 20%;\r\n  top: 6%;\r\n  /* left: 38%; */\r\n  z-index: 3;\r\n}\r\n\r\n.card_login {\r\n  position: relative;\r\n  width: 70%;\r\n  height: 70%;\r\n  border-radius: 14px;\r\n  z-index: 1;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  /* box-shadow:  20px 20px 60px #949494,\r\n    -20px -20px 60px #ffffff; */\r\n  background-color: #003757ef;\r\n  ;\r\n}\r\n\r\n.bg {\r\n  position: absolute;\r\n  top: 5px;\r\n  left: 5px;\r\n  width: 98%;\r\n  height: 98%;\r\n  z-index: 2;\r\n  background: rgba(255, 255, 255, .95);\r\n  background: linear-gradient(90deg, rgba(255, 254, 255, 1) 0%, rgba(195, 195, 195, 1) 100%);\r\n  backdrop-filter: blur(24px);\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  outline: 2px solid white;\r\n}\r\n\r\n.blob {\r\n  position: absolute;\r\n  z-index: 2;\r\n  top: 10%;\r\n  left: 10%;\r\n  width: 150px;\r\n  height: 150px;\r\n  border-radius: 50%;\r\n  background-color: #0076bb;\r\n  opacity: 1;\r\n  filter: blur(12px);\r\n  animation: blob-bounce 5s infinite ease;\r\n}\r\n\r\n@keyframes blob-bounce {\r\n  0% {\r\n    transform: translate(-100%, -100%) translate3d(0, 0, 0);\r\n  }\r\n\r\n  25% {\r\n    transform: translate(-100%, -100%) translate3d(100%, 0%, 0%);\r\n  }\r\n\r\n  50% {\r\n    transform: translate(-100%, -100%) translate3d(100%, 100%, 0);\r\n  }\r\n\r\n  75% {\r\n    transform: translate(-100%, -100%) translate3d(0, 100%, 0);\r\n  }\r\n\r\n  100% {\r\n    transform: translate(-100%, -100%) translate3d(0, 0, 0);\r\n  }\r\n}\r\n\r\n.login-box {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 80%;\r\n  padding: 40px;\r\n  margin: 20px auto;\r\n  transform: translate(-50%, -55%);\r\n  background: transparent;\r\n  /* box-sizing: border-box;\r\n    box-shadow: 0 15px 25px rgba(0,0,0,.6);\r\n    border-radius: 10px; */\r\n}\r\n\r\n.login-box p:first-child {\r\n  margin: 0 0 30px;\r\n  padding: 0;\r\n  color: #003757;\r\n  text-align: center;\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.login-box .user-box {\r\n  position: relative;\r\n}\r\n\r\n.user-box {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.login-box .user-box input {\r\n  width: 100%;\r\n  padding: 10px 0;\r\n  font-size: 16px;\r\n  color: #505050;\r\n  margin-bottom: 30px;\r\n  border: none;\r\n  border-bottom: 2px solid #003757;\r\n  border-right: 2px solid #003757;\r\n  outline: none;\r\n  background: transparent;\r\n}\r\n\r\n.login-box .user-box label {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  padding: 10px 0;\r\n  font-size: 18px;\r\n  font-weight: bolder;\r\n  color: #003757;\r\n  pointer-events: none;\r\n  transition: .5s;\r\n}\r\n\r\n.login-box .user-box input:focus~label,\r\n.login-box .user-box input:valid~label {\r\n  top: -20px;\r\n  left: 0;\r\n  color: #003757;\r\n  font-size: 12px;\r\n}\r\n\r\n.login-box form a {\r\n  position: relative;\r\n  display: inline-block;\r\n  padding: 10px 20px;\r\n  font-weight: bold;\r\n  color: #003757;\r\n  font-size: 16px;\r\n  text-decoration: none;\r\n  text-transform: uppercase;\r\n  overflow: hidden;\r\n  transition: .5s;\r\n  margin-top: 40px;\r\n  letter-spacing: 3px\r\n}\r\n\r\n.login-box a:hover {\r\n  background: #003757;\r\n  color: #ffffff;\r\n  border-radius: 5px;\r\n}\r\n\r\n.login-box a span {\r\n  position: absolute;\r\n  display: block;\r\n}\r\n\r\n.login-box a span:nth-child(1) {\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 2px;\r\n  background: linear-gradient(90deg, transparent, #003757);\r\n  animation: btn-anim1 1.5s linear infinite;\r\n}\r\n\r\n@keyframes btn-anim1 {\r\n  0% {\r\n    left: -100%;\r\n  }\r\n\r\n  50%,\r\n  100% {\r\n    left: 100%;\r\n  }\r\n}\r\n\r\n.login-box a span:nth-child(2) {\r\n  top: -100%;\r\n  right: 0;\r\n  width: 2px;\r\n  height: 100%;\r\n  background: linear-gradient(180deg, transparent, #003757);\r\n  animation: btn-anim2 1.5s linear infinite;\r\n  animation-delay: .375s\r\n}\r\n\r\n@keyframes btn-anim2 {\r\n  0% {\r\n    top: -100%;\r\n  }\r\n\r\n  50%,\r\n  100% {\r\n    top: 100%;\r\n  }\r\n}\r\n\r\n.login-box a span:nth-child(3) {\r\n  bottom: 0;\r\n  right: -100%;\r\n  width: 100%;\r\n  height: 2px;\r\n  background: linear-gradient(270deg, transparent, #003757);\r\n  animation: btn-anim3 1.5s linear infinite;\r\n  animation-delay: .75s\r\n}\r\n\r\n@keyframes btn-anim3 {\r\n  0% {\r\n    right: -100%;\r\n  }\r\n\r\n  50%,\r\n  100% {\r\n    right: 100%;\r\n  }\r\n}\r\n\r\n.login-box a span:nth-child(4) {\r\n  bottom: -100%;\r\n  left: 0;\r\n  width: 2px;\r\n  height: 100%;\r\n  background: linear-gradient(360deg, transparent, #003757);\r\n  animation: btn-anim4 1.5s linear infinite;\r\n  animation-delay: 1.125s\r\n}\r\n\r\n@keyframes btn-anim4 {\r\n  0% {\r\n    bottom: -100%;\r\n  }\r\n\r\n  50%,\r\n  100% {\r\n    bottom: 100%;\r\n  }\r\n}\r\n\r\n.login-box p:last-child {\r\n  color: #aaa;\r\n  font-size: 14px;\r\n}\r\n\r\n.login-box a.a2 {\r\n  color: #fff;\r\n  text-decoration: none;\r\n}\r\n\r\n.login-box a.a2:hover {\r\n  background: transparent;\r\n  color: #aaa;\r\n  border-radius: 5px;\r\n}\r\n\r\n.MessageErrorCont {\r\n  position: relative;\r\n  /* background-color: red; */\r\n  width: 100%;\r\n  height: 20%;\r\n  top: 80%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n}\r\n\r\n.MessageError {\r\n  position: relative;\r\n  width: 90%;\r\n  height: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 5px;\r\n  border: 3px solid #ff5959;\r\n  background-color: rgba(242, 199, 199, 0.72);\r\n}\r\n\r\n.txtMessageError {\r\n  position: relative;\r\n  width: 90%;\r\n  height: 90%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: red;\r\n  word-wrap: break-word;\r\n  font-size: small;\r\n}\r\n\r\n/************************Horizontal Movil*************************/\r\n@media (min-width: 500px) and (max-width: 900px) {\r\n  .login-box p:first-child {\r\n    font-size: 0.5rem;\r\n    top: 7%;\r\n    position: absolute;\r\n    left: 30%;\r\n\r\n  }\r\n\r\n  .login-box .user-box label {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .login-box .user-box input {\r\n    padding: 2%;\r\n  }\r\n\r\n  .actLogin {\r\n    font-size: 10px !important;\r\n  }\r\n\r\n  .actLogin.actDisabled {\r\n    font-size: 10px !important;\r\n  }\r\n}\r\n\r\n/************************Movil*************************/\r\n@media (max-width: 500px) {\r\n  .left-login {\r\n    width: 100%;\r\n    /* display: none; */\r\n  }\r\n\r\n  .rigth-login {\r\n    display: none;\r\n  }\r\n\r\n  .login-box p:first-child {\r\n    font-size: 1rem;\r\n    top: unset;\r\n    /* position: absolute; */\r\n    /* left: 30%; */\r\n\r\n  }\r\n\r\n  .cont-shadow-movil {\r\n    background: linear-gradient(#003757ef, #020a20f3);\r\n    z-index: 1;\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    top: 0%;\r\n  }\r\n\r\n  .cont-shadow-movil .logo-login {\r\n    height: 60%;\r\n  }\r\n\r\n  .txtMessageError {\r\n    font-size: var(--font-size-xSmall);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
